// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.2 14\"><path d=\"M5.6 14l-.5-.2C4.9 13.7 0 9.6 0 5.6a5.6 5.6 0 0111.2 0c0 4-4.9 8.1-5.1 8.2zm0-12.5a4.1 4.1 0 00-4.1 4.1c0 2.6 2.9 5.6 4.1 6.7 1.2-1.1 4.1-4.1 4.1-6.7a4.1 4.1 0 00-4.1-4.1zm0 5.1a.8.8 0 01-.8-.9c0-.2 0-.4.2-.5l.6-.3a.8.8 0 01.8.8.8.8 0 01-.8.9z\"/></svg>";
// Exports
module.exports = code;